import React, { useEffect, useRef, useState } from "react";
import "./ReviewFilterPostType.scss";
import DownArrowIcon from "../../../../../components/icons/DownArrowIcon";

interface Props {
  formik: any;
}

const ReviewFilterPostType: React.FC<Props> = ({ formik }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const postTypes = [
    { label: "Image Post", value: "image_post" },
    { label: "Video Post", value: "video_post" },
    { label: "Story Post", value: "story_post" },
    { label: "Reel Post", value: "reel_post" },
  ];

  const selected = postTypes.find(
    (option) => option.value === formik?.values?.selectedPostType
  );

  const handleSelect = (value: string) => {
    formik.setFieldValue("selectedPostType", value);
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="agent-contain-container" ref={containerRef}>
      <div className="agent-heading">
        <p>Post Type</p>
      </div>

      <div className="filter-search-listing">
        <input
          type="text"
          readOnly
          className="filter-search-input"
          value={selected?.label || "Select Post Type"}
          onClick={() => setOpen(!open)}
        />
        <div
          className={`filter-down-arrow-icon ${open ? "open-box" : ""}`}
          onClick={() => setOpen(!open)}
        >
          <DownArrowIcon />
        </div>
      </div>

      {open && (
        <div className="agent-list-container">
          {postTypes.map((option) => (
            <div
              key={option.value}
              className="agent-list-item"
              onClick={() => handleSelect(option.value)}
            >
              <p className="item-profile-name">{option.label}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReviewFilterPostType;
